import React from 'react';

const RecordOrEquivalent = () => {
  return (
    <div className="mt-2 govuk-bp:mt-5">
      <h1 className="govuk-heading-l">
        Lasting Power of Attorney for Health and Welfare
      </h1>
      <p className="govuk-body">
        Record of one or more people who have been given power (LPA) by the
        person when they had capacity to make decisions about their health and
        welfare should they lose capacity to make those decisions.
      </p>
      <p className="govuk-body">
        To be valid, an LPA must have been registered with the Court of
        Protection. If life-sustaining treatment is being considered the LPA
        document must state specifically that the attorney has been given power
        to consent to or refuse life-sustaining treatment. Details of any person
        (deputy) appointed by the court to make decisions about the person’s
        health and welfare. A deputy does not have the power to refuse
        life-sustaining treatment.
      </p>
    </div>
  );
};

export default RecordOrEquivalent;
